module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("2.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("KEIRA STOOD")]), _vm._v(" on Lissa’s doorstep, out of breath, with her green bag and rat in tow. She knocked twice. Lissa answered the door and then gave Keira the once-over. “So did you have a fight or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sort of. I don’t want to talk about it. I’m kind of freaked out right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s cool. Maybe later?” Lissa said as she guided her friend into the well-lit foyer. “You know, my mom’s at her boyfriend’s all night. We have the whole condo to ourselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh my God. That’s great.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You brought the rat. Is he your new pet or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Or something,” Keira said, already uncomfortable being questioned. “Can we talk about something else right now?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure. You wanna get high?” Lissa asked hopefully as she closed the front door behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure. What do you have?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Some Cannabril XL. It’s totally funky.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ve never heard of it. Is it cool?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("double-V")]), _vm._v(" cool. I think it’s Taiwanese. And then we can order a pizza,” Lissa said as she took the green bag from Keira’s hand. “I have my mom’s Visa Pay.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She’s not wearing it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s her old one, but it still works.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s what I love about you, Lissa,” Keira said, smiling. “You are so "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("together")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The two girls giggled and ran upstairs to Lissa’s bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“HAVE YOU")]), _vm._v(" named him yet?” Lissa asked as she peered at the brown rat. He was cleaning his shiny whiskers with his pink front paws. “He’s so cute. And to think we almost killed him today.” She stepped away from the cage and pushed a chunk of synth-pot into her e-pipe and vaped it. Lissa exhaled up toward the ceiling and handed the silver pipe to Keira.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know. I hate science class,” Keira replied as she put the pipe to her lips and took a drag. She held her breath and handed the pipe back to Lissa, then exhaled. “I haven’t really thought of a name for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He looks like a Fred,” Lissa said and took another deep drag before handing the pipe to Keira again, who did the same.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fred")]), _vm._v("?” Keira said as she exhaled a pale cloud of smoke and coughed. “That’s not a good name.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure it is. Isn’t that right, Fred?” Lissa asked as she looked at the rat and reached for the pipe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“This stuff is strong,” Keira said. “I’m kind of floating already, but I still feel clearheaded.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There’s adrenaline in the blend,” Lissa said while trying to keep down a big lungful. She suddenly began coughing uncontrollably. Puffs of vaped synth-pot rushed out of her nose and mouth as she sputtered and choked. Keira started laughing. Lissa was quiet for a moment, then joined in laughing. Soon they were both hysterical, tears streaming from their eyes, their diaphragms aching, out of breath. They fell back onto Lissa’s downy bed, side by side. After their giggles subsided, Lissa sat up. “Let’s get that pizza now.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh yeah! A large,” Keira said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“With extra cheese.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And olives.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Where’s my phone?” Lissa asked as she looked over the side of the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Is that it there?” Keira asked, pointing at the phone on Lissa’s dresser.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Duh!” Lissa said, standing to retrieve it. She plopped back down on the bed and pressed her finger to the phone screen. “Pizza delivery.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The phone dialed, and then a voice answered, “Vincenzo’s Pizza. What can I get for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hi,” Lissa giggled. “We want a large pizza with extra cheese.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And olives,” Keira whispered loudly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And pepperoni and green peppers.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And mushrooms,” Keira added, laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sounds like you girls are having a party,” the man said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What? Yeah, a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("pizza")]), _vm._v(" party. So where’s that pizza?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hold on,” the man said. “A large pepperoni, olive, mushroom, green pepper pizza.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“With extra cheese,” Lissa interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“With extra cheese. Yeah, I got it. Anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” Lissa said, shaking her head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes,” Keira interjected. “We want it delivered.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh yeah. We want it delivered, that’s right!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Go ahead and bump your payment,” said the man on the other end of the line.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wait a second,” Lissa said, then turned to face Keira. “I have to get the Visa Pay. Here, hold this.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lissa handed Keira the phone and then scrambled into the other room.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Just a moment,” Keira said as she waited awkwardly, trying to suppress a giggle. Lissa returned and brought the small black fob up to the cell phone and touched them. “We’re back.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay. Here it comes,” the man said. “All right. Got the payment and the address. That will be about twenty-five minutes. And don’t tip the driver. He’s not supposed to take tips.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We won’t. Don’t worry,” Lissa said, laughing, and then hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Doesn’t your mother wonder about the extra charges?” Keira asked and pointed to the payment device.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“If she does, she hasn’t said anything to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I could never get away with that,” Keira said as she pulled her legs up onto the bed and sat cross-legged.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What are they like anyway?” Lissa asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What are who like?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Your fosters. Are they assholes?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. That’s why I’m here with all my clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And Fred the rat,” Lissa added.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And Fred too, yeah,” Keira said. “I’m not going back there.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What? But why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Lots of reasons,” Keira said enigmatically and paused. “I’m thinking about getting out of LA. Maybe hitchhiking down to San Diego or up to Portland.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lissa stared blankly at her friend for a moment. “Really?” she said, then, clearly very interested, she added, “Take me with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What? You want to go?” Keira asked, leaning forward.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Please? We could go together. It’ll be fun. Just you and me. I’ve got some money saved up. We wouldn’t have to hitchhike the whole time.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wow, that’s a really good idea. It’s safer to travel as a pair. But we’ll have to get your stuff packed tonight. What time is it?” Keira scanned the walls for a clock. Lissa didn’t answer, but instead held her phone up in front of Keira. They both laughed again. It said 7:38 p.m. It was the last week of October, and getting darker earlier and earlier outside. It made it hard to tell what time it was in the evening.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We can pack after the pizza,” Keira said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And one more thing,” Lissa said suddenly. “I have a surprise for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“For me?” Keira asked, trying not to blush.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“For both of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lissa shook her head. “You’ll see, tonight before we go to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That sounds mysterious.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s something we’ve both been curious about,” Lissa said with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Now I really want to know what it is!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THE CONDO")]), _vm._v(" doorbell rang.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That was fast,” Keira said as she stood up from the living room couch. “I’ll get the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Alexa, pause the movie,” Lissa said to the digital assistant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay,” Alexa replied in her robotic voice as the video paused.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Remember, no tip,” Lissa said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No tip!” Keira shouted back at her from down the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira turned the brass doorknob. The front door opened to reveal a twentysomething, dark-haired, ruggedly handsome pizza-delivery guy, a box on his right arm, and his other arm in a black nylon sling. Keira recoiled for a moment, the scene with her foster-father suddenly replaying at full volume, the sparks, the blinding flash, and his right arm breaking off and shattering on the floor. The images ran over and over in a sickening loop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Did it really happen? What’s going on with me? Stay cool. Don’t freak out. You’re too high, calm down.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Here you go,” the young man said, extending the pizza box.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira took a step back and froze. She felt like throwing up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Didn’t you order a pizza?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira snapped out of it. “I’m sorry. Yeah, we did. Thanks,” she said and took the box into her arms. “Is that it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yep. See you around,” the pizza guy replied and walked back to his red Prius.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira shut the front door and walked slowly back through the foyer to the living room. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Should I call and see if Steve is okay? No, better not. What even happened to him? That was so scary! And that poor rat in the science lab. What’s happening to me? Calm down. Keep it together. I’m outta here tomorrow anyway. Who knows what they would do to me if I stuck around. As if I didn’t already have enough reasons to leave! At least Lissa is coming with me. That will make it easier. Maybe we’ll have some fun on the way?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Where’s that pizza?” Lissa called out from the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Coming!” Keira answered and quickened her pace.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“DO YOU")]), _vm._v(" need to borrow a sleep shirt?” Lissa asked from her bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, I have one,” Keira said as she got out her toothbrush and floss. She turned to look at the rat. He was sitting in the corner of the cage staring up at her with inquisitive eyes. “Do you have anything we could feed Fred?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Like what?” Lissa asked while brushing her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know. Salad mix? Aren’t rats vegetarians?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think they’ll eat anything,” Lissa said, putting her brush aside. “Give him some leftover pizza. It’s on the kitchen counter.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira put her toothbrush and floss on the bedspread and went downstairs to the brightly lit kitchen. She pulled out a half-eaten crust and then went back upstairs. Fred watched her attentively, as if he knew what she had gone to get and had been waiting for her to come back. The rat perched at the side of the cage. His right paw extended, grabbing at the air, through the metal bars.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh, so you do want pizza,” Keira said to her pet. “Here you go.” She tore a tiny piece from the crust and pushed it through the wires to the rat. He took it in his two pink paws and began to eat greedily. “Wow, you’re really hungry. Sorry, I’m not used to taking care of someone other than me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who are you talking to?” Lissa stuck her head out of the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Fred. He was really hungry. I gave him some pizza.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Do you need to use the bathroom? I’m done.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I have to brush my teeth,” Keira said as she put the rest of the pizza crust into the cage and turned to retrieve her toothbrush and floss.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s all yours,” Lissa said as she emerged wearing a pink nighty, her brown hair pulled up into a topknot.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You look so cute,” Keira said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“For real?” Lissa asked. “Or are you kidding?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really, you do. My hair never looks like that when I put it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thanks,” Lissa replied with a grin. “I wish I had red hair like yours. It looks like Copper on Fire. That’s the name of my favorite lipstick.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thanks, I guess,” Keira said and entered the bathroom to begin her bedtime ritual. When she had completed brushing her teeth and then her long hair, she slipped off her black jeans, shirt and bra, and put on a gray sleep shirt. Carrying her clothes over her arm, she returned to the bedroom to find Lissa sitting up in the queen size bed, a large pink box on top of the covers in front of her. Lissa patted the bed next to her. Keira put her clothes in her green bag and then joined Lissa in the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Is that my surprise?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. It was two-for-one online. They’re called Heavenly Butterflies.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m dying,” Keira laughed. “Open the box.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lissa looked at Keira and then lifted off the lid. Keira saw two pink butterfly-shaped devices with glittering wings, each about five inches across, neatly tucked into plastic cases. She looked at Lissa with both intrigue and confusion. “What are they?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You don’t know?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No. Are they something you wear?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Kind of,” Lissa said and tittered mischievously. “They do go on the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("outside")]), _vm._v(" of your body.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Recognition washed across Keira’s face. She smiled and covered her grin with a bashful hand. “Vibrators?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Aren’t they neat?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh my God, are you serious?” Keira asked as she lifted a silicone butterfly up for closer inspection.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We don’t have to use them now, but they’ll be fun for the trip, don’t you think? You wear them under your panties and they’re remote controlled.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I never would have guessed in a million years you’d have bought these, that’s for sure,” Keira said and dropped the small box back into the larger one. “What time will your mother be back tomorrow morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Around 8:00, then she goes to the gym.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’ll have to be out of here by 7:30 a.m. at the latest.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Everything is packed and ready. I’ll call her once we get where we’re going,” Lissa said as she placed the butterflies on the floor and snuggled under the covers. “Are you sure we can find a ride? I probably have enough money for two bus tickets.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m sure. I’ve hitchhiked a bunch of times. Save your money for later. We have to be careful about pervy creeps,” Keira said, sounding very much like the voice of experience. “Let’s get to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay. I am tired. Good night,” Lissa said as she stretched up to kiss Keira’s cheek. “I’m so glad we’re friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Me too,” Keira said and turned off the light.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“KEIRA!”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira thought she heard someone calling her name, a stranger’s voice. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("No, it’s nothing")]), _vm._v(". She rolled over onto her left side and pulled the comforter up over her head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Keira! You have to wake up. Keira!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira sat up in bed and tried to figure out who was talking to her. It sounded like a man, but no one else was in the condo. It was pitch black in Lissa’s bedroom. Keira rubbed her eyes, decided she was dreaming, and lay back down.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, don’t go back to sleep! You have to get up! They’re here! Keira! We have to leave right now!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who are you?” Keira asked with alarm as she sat up again and turned on the bedside lamp. No one was there. She glanced at Lissa who was still asleep, and then looked out into the dark hallway. Nothing. Something rattled loudly to her right. Keira turned to see Fred standing in his cage, staring right up at her, both his pink paws on the metal door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Keira!” the rat said. “We have to leave! Get up and let me out!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira’s mind spun again. She felt sick and dizzy. “Oh my God, I am hallucinating from that synthetic hash!” She shook her head. “I hope there wasn’t acid or"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("MDMA in it. I’ve got to get back to sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Keira, you are not hallucinating! My name’s Tenzing, not Fred! Let me out of this cage!” the rat demanded and shook the metal door again. Keira stared at the rodent. He stared at Keira with a pleading looking in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you talking to me?” Keira asked, feeling foolish speaking to a pet rat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes! I don’t have time to explain this right now. They’re coming for you. I heard them talking outside a few minutes ago. I have excellent hearing,” Tenzing said while pacing frantically in his cage. “We have to leave now!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What do you mean? Who’s here?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Someone named Holcomb and his men. I guess he’s their boss. He gave them their orders and left. They hunt ‘Star Children’ like you. He wants to sell you to the Brazilians.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What? What’s going on here? You can’t be talking! Am I being punked?” Keira smiled and looked around the room for any sign of a hidden camera. “For real! What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The sound of a window breaking downstairs echoed up the hallway. Keira jumped. She turned to Lissa, who was still fast asleep. Keira shook her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Lissa! Wake up! There’s someone breaking into the house!” she whispered loudly at the comatose girl. No response. Keira grabbed Lissa violently by the shoulders. “Lissa, wake up!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You can’t wake her. They’ve turned her off,” Tenzing said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I heard one of Holcomb’s men say that downstairs. They have someone with them, a ten-year-old boy, Alexander. He has the power to shut people off like a light switch. She won’t wake up,” the rat’s panicked voice rose up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why am I still awake then?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know!” Tenzing said, now completely freaked out. “Maybe that’s why they want you—because you can’t be turned off? But we don’t have time for this. Let me out of the cage! We need to escape!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Without a second thought Keira stood up and unlatched the tiny metal door. Tenzing hopped out and jumped up on Keira’s chest and crawled onto her left shoulder. “That’s better. Quick, put your school ID in Lissa’s purse.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What? Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Just do it. Take Lissa’s ID and switch it with yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But we don’t look at all alike.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It doesn’t matter; it will slow them down. They’ll scan the room for it. They won’t take a look at it. They have to be sure they grabbed the right girl. Take any money she has in there too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira did as the rat said. Then she pulled on her black jeans and tucked in her nightshirt. Keira turned to go to the bathroom, but Tenzing interrupted her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Forget about your toothbrush.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I have to put on my shoes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There’s no time! Turn off the light, grab your bag, and climb out the window.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But it’s so high up.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’ll be fine. Now do it!” Tenzing insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira picked up her bag, turned the light off, opened the window, and kicked the screen out. She crawled out and stood barefoot on the roof. The moon shone brightly above her, illuminating the grounds below. Tenzing clung to her shoulder, his little heart beating fast. The pounding of footsteps came up the staircase and rang out in the hall. Keira quickly pulled the window shut and knocked the mesh screen off the roof.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What now?” she whispered. She stood as close to the condo as she could, right up under the shingled eaves.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Jump!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” she gasped while looking down. “It’s like fifteen feet.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Not straight down. Jump over there into those thick hedges.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh my God! This is so crazy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A loud crash came from inside the house. Keira pulled Tenzing from her shoulder and shoved him into her bag, held her breath, and leaped into the darkness. The next thing she knew, thick branches were snapping and breaking her fall and scratching her arms and face. She landed with a thump, unhurt but very, very frightened. Keira got up and pushed her way out of the overgrown shrubbery. Across the condo complex, she saw a metal gate that led to a dark parking lot.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you okay,” she whispered to Tenzing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes!” came the muffled reply. “Let’s get out of here. Hurry!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Keira held the green bag to her chest and ran as fast as she could through the darkness between the carefully landscaped trees. When she reached the community gate, she opened it and hurried through. Tenzing and Keira disappeared into the muggy San Pedro night.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f5746a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0007.vue
// module id = 75
// module chunks = 0